import React from 'react';

const Help = () => {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">Support</h6>
                    <h1 className="mb-5">Help & Support</h1>
                </div>
                <div className="row g-4">
                    <div className="col-lg-12">
                        <h2>Frequently Asked Questions</h2>
                        
                        <h4>How do I reset my password?</h4>
                        <p>You can reset your password by clicking on the "Forgot Password" link on the login page. You will receive an email with instructions on how to reset your password.</p>

                        <h4>How do I enroll in a course?</h4>
                        <p>To enroll in a course, navigate to the course page and click the "Enroll Now" button. You will be prompted to log in or create an account if you haven't already.</p>

                        <h4>How can I contact customer support?</h4>
                        <p>You can contact our customer support team by emailing us at support@fundisha.com or by using the contact form on our contact page. We typically respond within 24 hours.</p>

                        <h4>Do you offer refunds?</h4>
                        <p>Yes, we offer a 30-day money-back guarantee on all of our courses. If you are not satisfied with a course, you can request a full refund within 30 days of purchase.</p>

                        <h4>Are there any prerequisites for the courses?</h4>
                        <p>Some courses may have prerequisites, which will be listed on the course details page. Please review the prerequisites carefully before enrolling in a course.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Help; 